import React, { useEffect, useState } from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
  CFormInput,
  CFormSelect,
  CButton,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CFormLabel,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStockList, updateStock } from "../../features/seller/sellerSlice";
import { data } from "react-router-dom";
import AppLoader from "../../components/seller/AppLoader";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import AppToast from "../../components/seller/AppToast";

import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../utils/price";

const initialStock = [
  { id: 1, name: "Aluminium Sheet", stock: 120 },
  { id: 2, name: "Copper Wire", stock: 80 },
  { id: 3, name: "Brass Rod", stock: 45 },
];

const validationSchema = Yup.object({
  quantityToAdd: Yup.number()
    .typeError("Quantity must be a number")
    .integer("Quantity must be an integer")
    .min(1, "Quantity must be at least 1")
    .required("Quantity is required"),
});

const ManageStock = () => {
  const dispatch = useDispatch();
  const { list: stockData, loading } = useSelector(
    (state) => state.seller.stock
  );
  console.log("Stock Data:", stockData);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [visible, setVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");

  useEffect(() => {
    dispatch(fetchStockList())
      .unwrap()
      .catch((error) => {
        console.log("Failed to load stock list", error);
      });
  }, [dispatch]);

  const filtered = stockData.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / entriesPerPage);

  const handleOpenModal = (product) => {
    setSelectedProduct(product);
    setVisible(true);
  };

  const handleUpdateStock = async (quantity) => {
    const payload = {
      quantity: parseInt(quantity),
    };

    try {
      const res = await dispatch(
        updateStock({ id: selectedProduct.id, data: payload })
      ).unwrap();
      setVisible(false);
      dispatch(fetchStockList());

      setToastType("success");
      setToastMessage(res?.message || "Stock updated successfully!");
      setToastVisible(true);
    } catch (error) {
      console.log("Update failed:", error);
      const errorMsg =
        error?.message ||
        error?.error ||
        "Failed to update stock. Please try again.";

      setToastType("error");
      setToastMessage(errorMsg);
      setToastVisible(true);
    }
  };

  // Navigation hook for row click product detail
  const navigate = useNavigate();

  const handleRowClick = (item) => {
     navigate(`/seller/product-detail/${item.id}`);
  };

  if (loading) return <AppLoader />;

  return (
    <>
      <div className="container-fluid px-3">
        <CRow className="mt-4 mb-3">
          <CCol>
            <h4 className="mb-0">My Product Stock</h4>
          </CCol>
        </CRow>

        <CCard>
          <CCardHeader>
            <CRow className="align-items-center">
              <CCol md={6}>
                Show{" "}
                <CFormSelect
                  size="sm"
                  value={entriesPerPage}
                  onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                  style={{ display: "inline-block", width: "auto" }}
                  options={[
                    { label: "5", value: "5" },
                    { label: "10", value: "10" },
                    { label: "25", value: "25" },
                  ]}
                />{" "}
                entries
              </CCol>
              <CCol md={6} className="text-end">
                Search:{" "}
                <CFormInput
                  type="text"
                  size="sm"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ display: "inline-block", width: "200px" }}
                />
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CTable responsive bordered hover align="middle">
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell>#</CTableHeaderCell>
                  <CTableHeaderCell>Product Name</CTableHeaderCell>
                  <CTableHeaderCell>Current Stock</CTableHeaderCell>
                  <CTableHeaderCell>Unit</CTableHeaderCell>
                  <CTableHeaderCell>Price (AUD)</CTableHeaderCell>
                  <CTableHeaderCell>Actions</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {currentData.map((item, index) => (
                  <CTableRow key={item.id} style={{ cursor: "pointer" }} onClick={() => handleRowClick(item)}>
                    <CTableDataCell>{indexOfFirst + index + 1}</CTableDataCell>
                    <CTableDataCell>{item.name || "-"}</CTableDataCell>
                    <CTableDataCell>
                      {item.current_stock !== null &&
                      item.current_stock !== undefined &&
                      item.current_stock !== ""
                        ? item.current_stock
                        : "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {item.unit_of_measurement || "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {formatCurrency(item.price)}
                      {/* {item.price !== null &&
                      item.price !== undefined &&
                      item.price !== ""
                        ? `A$ ${item.price}`
                        : "-"} */}
                    </CTableDataCell>
                    <CTableDataCell>
                      <CButton
                        size="sm"
                        color="info"
                        className="me-2"
                        
                         onClick={(e) => {
                          e.stopPropagation();
                          handleOpenModal(item);
                        }}
                      >
                        Update Stock
                      </CButton>
                    </CTableDataCell>
                  </CTableRow>
                ))}
                {currentData.length === 0 && (
                  <CTableRow>
                    <CTableDataCell
                      colSpan="5"
                      className="text-center text-muted"
                    >
                      No stocks found.
                    </CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Showing {indexOfFirst + 1} to{" "}
                {Math.min(indexOfLast, filtered.length)} of {filtered.length}{" "}
                entries
              </div>
              <div className="d-flex align-items-center">
                <CButton
                  size="sm"
                  color="light"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="me-2"
                >
                  Prev
                </CButton>

                {[...Array(totalPages)].map((_, i) => (
                  <CButton
                    key={i}
                    size="sm"
                    color={currentPage === i + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(i + 1)}
                    className="me-2"
                  >
                    {i + 1}
                  </CButton>
                ))}

                <CButton
                  size="sm"
                  color="light"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </CButton>
              </div>
            </div>
          </CCardBody>
        </CCard>

        <CModal
          visible={visible}
          onClose={() => setVisible(false)}
          alignment="center"
        >
          <CModalHeader closeButton>
            Update Stock for {selectedProduct?.name}
          </CModalHeader>
          <Formik
            initialValues={{ quantityToAdd: "" }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              handleUpdateStock(values.quantityToAdd);
              setSubmitting(false);
            }}
          >
            {({
              values,
              setFieldValue,
              handleBlur,
              touched,
              errors,
              isSubmitting,
            }) => (
              <Form>
                <CModalBody>
                  <CFormLabel>Quantity to Add</CFormLabel>
                  <CFormInput
                    type="number"
                    min={1}
                    name="quantityToAdd"
                    value={values.quantityToAdd}
                    onChange={(e) =>
                      setFieldValue("quantityToAdd", e.target.value)
                    }
                    onBlur={handleBlur}
                    placeholder="Enter quantity"
                  />
                  {touched.quantityToAdd && errors.quantityToAdd && (
                    <div className="text-danger">{errors.quantityToAdd}</div>
                  )}

                  <div className="mt-3">
                    <CFormLabel>Unit</CFormLabel>
                    <CFormInput
                      value={selectedProduct?.unit_of_measurement || "-"}
                      disabled
                    />
                  </div>
                </CModalBody>
                <CModalFooter>
                  <CButton
                    color="primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Update Stock
                  </CButton>
                </CModalFooter>
              </Form>
            )}
          </Formik>
        </CModal>
      </div>
      <AppToast
        visible={toastVisible}
        setVisible={setToastVisible}
        type={toastType}
        title={toastType === "success" ? "Success" : "Error"}
        message={toastMessage}
      />
    </>
  );
};

export default ManageStock;
